import React from "react";
import { NavLink } from "react-router-dom";

export const MAIN_NAV_LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/produits", label: "Boutique" },
  { to: "/a-propos-de-nous", label: "Qui sommes-nous" },
  { to: "/contact", label: "Contact" },
] as const;

function FrontMainNav() {
  return (
    <nav className="front-main-nav" aria-label="Navigation principale">
      <div className="front-main-nav-inner">
        {MAIN_NAV_LINKS.map(({ to, label }) => (
          <NavLink
            key={label}
            to={to}
            className={({ isActive }) =>
              `front-main-nav-link${
                isActive ? " front-main-nav-link-active" : ""
              }`
            }
            end={to === "/"}
          >
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

export default FrontMainNav;